import styled from "styled-components";

export const StyledLegal = styled.div`
  background-color: white;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`;
